import React, { Component } from 'react';
import Floater from 'react-floater';
import Overlay from './overlay';
import styles from './styles.module.scss';

export default class TeamMember extends Component {
  state = { open: false };

  onClick = () => {
    const { open } = this.state;
    this.setState({ open: !open });
  };

  render() {
    const { name, position, image, quote } = this.props;
    const { open } = this.state;
    return (
      <div className="d-flex flex-row justify-content-center">
        <div className={styles.teamMember}>
          <img src={image} alt={name} />
          <div className={styles.memberCard}>
            <strong>{name}</strong>
            <small className="mb-3">{position}</small>
            <Floater
              content={quote}
              open={open}
              title="What drives me"
              styles={{ floater: { maxWidth: 600 } }}
            >
              <span onClick={this.onClick} className={styles.learnMore}>
                Learn More
              </span>
            </Floater>
            {open && <Overlay onClick={this.onClick} />}
          </div>
        </div>
      </div>
    );
  }
}
